import React from "react"
import styles from "./styles.scss"
import SideNav from "components/SideNav"
import Table from "components/Table"
import { Link } from "react-router-dom"
import { companyEditPath } from "utils/paths"
import {
  destroyCompany,
  getCompanies,
  getCompaniesBySearch,
  selectCompaniesAsArray,
} from "data/companies"
import { connect } from "react-redux"
import AdminHeader from "../../components/AdminHeader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Waypoint from "react-waypoint"

class CompanyIndex extends React.Component {
  state = {
    currentPage: 1,
    searchValue: ''
  }

  componentDidMount() {
    const { currentPage } = this.state
    this.props.getCompanies(currentPage)
  }

  _handleWaypointEnter = () => {
    const { currentPage, searchValue } = this.state
    if (!searchValue) {
    this.props.getCompanies(currentPage)
    this.setState({ currentPage: this.state.currentPage + 1 })
    }
  }

  handleSearchChange = event => {
    this.setState({searchValue: event.target.value})
    this.props.getCompaniesBySearch(event.target.value)
  }

  onDelete = id => {
    window.confirm("Är du säker att du vill ta bort företaget?") &&
      this.props.destroyCompany(id)
  }

  render() {
    const { companies } = this.props

    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader />
          <div className={styles.companyTableWrapper}>
            <SideNav type="companies" />
            <div className={styles.companyTable}>
              <Table title={"Företag"} onSearchChange={this.handleSearchChange}>
                <thead>
                  <tr>
                    <th>Namn</th>
                    <th>Telefonnummer</th>
                    <th>Epost</th>
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {companies.map(company => (
                    <tr className={styles.everyTwo} key={company.id}>
                      <td>{company.name}</td>
                      <td>{company.phone}</td>
                      <td>{company.email}</td>
                      <td className={styles.pencilIcon}>
                        <Link to={companyEditPath(company.id)}>
                          <FontAwesomeIcon icon="pencil-alt" />
                        </Link>
                      </td>
                      <td
                        className={styles.deleteField}
                        onClick={() => this.onDelete(company.id)
                        }
                      >
                        <FontAwesomeIcon icon="trash-alt" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Waypoint onEnter={this._handleWaypointEnter} />

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  companies: selectCompaniesAsArray(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getCompanies,
    getCompaniesBySearch,
    destroyCompany,
  }
)(CompanyIndex)



// WEBPACK FOOTER //
// src/pages/Admin/Companies/CompanyIndex/index.jsx